import React, { useEffect, useRef } from 'react';
import { useInView, useMotionValue, animate } from 'framer-motion';

/* Counts up from 0 to `value` when scrolled into view. */
const Counter = ({ value, decimals = 0, duration = 1.8, prefix = '', suffix = '' }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  const count = useMotionValue(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(count, value, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (latest) => {
        if (ref.current) {
          ref.current.textContent =
            prefix +
            Number(latest).toLocaleString('en-US', {
              minimumFractionDigits: decimals,
              maximumFractionDigits: decimals,
            }) +
            suffix;
        }
      },
    });
    return controls.stop;
  }, [inView, value, decimals, duration, prefix, suffix, count]);

  return <span ref={ref}>{prefix}0{suffix}</span>;
};

export default Counter;
